



import { SfDivider } from '@storefront-ui/vue';
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Divider',
  components: {
    SfDivider
  },
  props: {
    margin: { type: Number, default: 0 }
  }
});
